// src/store/index.js
import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import mutations from './mutations'
import actions from './action'
import getters from './getter'

import member from './modules/member'
import citySelect from './modules/citySelect'
import city from './modules/city'
import createPersistedState from 'vuex-persistedstate'//引入vuex-persistedstate这个插件

Vue.use(Vuex)

/** 如果把整个store都放在index.js中是不合理的，所以需要拆分。比较合适的目录格式如下：
 store:.
 │  actions.js
 │  getters.js
 │  index.js
 │  mutations.js
 │  mutations_type.js   ##该项为存放mutaions方法常量的文件，按需要可加入
 │
 └─modules
 Astore.js
 */

/** vuex数据持久化解决方案
 why
 在vuex的时候刷新以后里面存储的state就会被浏览器释放掉，因为我们的state都是存储在内存中的，所以一刷新页面就会把state中的数据重置，这就涉及到vue数据持久化的问题。
 what？
 解决方案通过 vuex-persistedstate这个插件，来实现将数据存储到本地，从而实现刷新后state仍然还存在。
 how？
 npm install vuex-persistedstate --save进行安装，然后import进行引入，new了一个插件的原型，最后要export导出
 */

const persistedState = createPersistedState({ //使用
  key: 'vuex', // 讲状态存储在存储中的键 默认vuex
  storage: window.localStorage, //可传localStorage sessionStorage localforage 或者自定义的存储对象，接口必须要有get和set
  // reducer: state => ({ // 将状态减少到只需要保存的值，默认情况下，保存整个状态
  //   logined: state.logined,
  //   user: state.user,
  //   permissions: state.permissions,
  //   menus: state.menus
  // })
})

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {
    member,
    citySelect,
    city
  },
  plugins: [persistedState]//导出
})


// WEBPACK FOOTER //
// ./src/store/index.js